<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="'Add New Cloud Storage Account'">
  <div modal-body>
    @let currency = (balance | async)?.subscriptionCurrencySign;
    <p>
      You are already using MSP360 (Amazon&nbsp;S3) storage. Along with&nbsp;it, we&nbsp;offer
      <a
        href="/AP/Help/administration/licenses/aws-ub-licenses"
        target="_`blank">
        some licenses
      </a>
      at&nbsp;a&nbsp;discounted price. With the new cloud storage account added, the discount for
      {{ credits?.licenseCount }} licenses in&nbsp;use will be&nbsp;revoked.
    </p>
    <p>
      To&nbsp;add a&nbsp;new cloud storage account, you will need to&nbsp;pay the difference. Total surcharge:
      {{ currency }}{{ credits?.surchargeTotal }}
    </p>

    @if (credits?.surchargeLeft > 0) {
      <p>
        The surcharge amount will be&nbsp;partially covered with credits {{ currency }}{{ credits?.creditsLeft }} and the rest of&nbsp;the
        amount {{ currency }}{{ credits?.surchargeLeft }} will be&nbsp;charged from your account
      </p>
    } @else {
      <p>
        The surcharge will be&nbsp;covered with your credits. Currently, you have
        {{ currency }}{{ credits?.creditsTotal }} in&nbsp;credits
      </p>
    }
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="success"
      [loading]="loading$ | async"
      (click)="handleResolve()">
      Pay
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      Close
    </mbs-button>
  </ng-container>
</mbs-modal>
